import {
  ClientResponse,
  EmployeeResponse,
  EventResponse,
  PlanningEntityIdentifier,
  ResourceResponse,
  WorkPlaceResponse
} from 'generated/index';
import { EntityUnion } from './EntityQuickDisconnect.types';

export const getEntityLabel = (entity: EntityUnion): string => {
  const name =
    entity.displayName ||
    entity.nameInformal ||
    entity.fullName ||
    entity.name ||
    '';

  return entity.planningEntityType === 'CLIENT' && entity.number != null
    ? `${name} (${entity.number})`
    : name;
};

export const getDeselectedClients = (
  clients: ClientResponse[],
  entity: EntityUnion
) => {
  return clients?.filter((e) => e.id !== entity?.id);
};

export const getDeselectedEmployees = (
  employees: EmployeeResponse[],
  entity: EntityUnion
) => {
  return employees?.filter(
    (e) => e.id !== entity?.id || e.entityId !== entity?.entityId
  );
};

export const getDeselectedResources = (
  resources: ResourceResponse[],
  entity: EntityUnion
) => {
  return resources?.filter((e) => e.id !== entity?.id);
};

export const getDeselectedWorkPlace = (
  workPlace: WorkPlaceResponse | undefined,
  entity: EntityUnion,
  currentWorkPlaceId: string | undefined
) => {
  return workPlace?.entityId !== entity?.entityId
    ? currentWorkPlaceId
    : undefined;
};

export const extractPlanningEntityIdentifiersFromPlanningEvent = (
  planningEvent: EventResponse
) => {
  return [
    ...planningEvent.employees.map((employee) => ({
      entityId: employee.entityId,
      number: employee.number,
      planningEntityType: 'EMPLOYEE'
    })),
    ...planningEvent.clients.map((client) => ({
      entityId: client.id,
      number: client.number,
      planningEntityType: 'CLIENT'
    })),
    ...(planningEvent.resources || []).map((resource) => ({
      entityId: resource.id,
      planningEntityType: 'RESOURCE'
    })),
    ...(planningEvent.workPlace
      ? [
          {
            entityId: planningEvent.workPlace.entityId,
            planningEntityType: 'WORKPLACE'
          }
        ]
      : [])
  ] as PlanningEntityIdentifier[];
};
